import { Injectable } from '@angular/core';
import {ParentTableService} from './parent-table.service';
import { ODataEntitySetService, ODataServiceFactory } from 'angular-odata';
import {Qualification} from '../../models/qualification';
import {exportable$} from './decorators/exportable';
import {map} from 'rxjs/operators';
import {ODataResponseMapper} from './mappers/odata-response-mapper';
import {SQDataConfiguration} from './configuration/OData-configuration';
import {HelperFunctions} from './configuration/helper-functions';
import {QUALIFICATION_FLOW} from './configuration/constants';

@Injectable({
  providedIn: 'root'
})
export class RelocationService extends ParentTableService {
  private odata: ODataEntitySetService<Qualification>;
  private readonly config: SQDataConfiguration;
  @exportable$ relocation: any;

  constructor(public odataFactory: ODataServiceFactory) {
    super('RelocationService');
    this.odata = this.odataFactory.entitySet<Qualification>('Overview(0)/Qualification');
    this.config = new SQDataConfiguration();
  }

  getData(pageIndex, count, sortModel, filterModel) {
    const orders = [];
    sortModel.forEach(x => orders.push(x.colId.replace(/\./g, '/') + ' ' + x.sort));

    let filter = `CurrentFlow eq ${QUALIFICATION_FLOW.Standard}`;
    filterModel['QualificationTool'] = {
      filter: 'Relocation',
      filterType: 'text',
      type: 'equals'
    };
    filter = HelperFunctions.addOdataFilters(filter, filterModel);

    const query = this.odata.entities().query(q => {
      q.top(count);
      q.skip(count * pageIndex);
      if (orders.length > 0) q.orderBy(orders);
      if (filter?.length) q.filter(filter);
      return q;
    });

    this.relocation = query;
    return this.relocation.fetch({ withCount: true }).pipe(map((r: any) => ODataResponseMapper.mapResponse(r)));
  }
}
